angular.module('accessWebClient')
    .controller('TransferController', ['$q', '$scope', '$translate', function ($q, $scope, $translate) {
        var FIELDS = [
                'uuid',
                'name',
                'read_only',
                'has_writable_children',
                'synced',
                'is_shared',
                'owner_email',
                'parents',
                'permissions'
            ].join(','),
            actionTitle = $scope.modal.title,
            actionButton = $scope.modal.actionButton,
            buttonOverrideTitle = $translate.instant('Overwrite'),
            sourceNode = $scope.elements[0],
            isSingleSourceNode = $scope.elements.length === 1;

        $scope.current = {};
        $scope.currentChildren = [];
        $scope.goTo = _goTo;

        $scope.modal.loading = true;
        $scope.modal.disableSubmit = function () {
            return $scope.current['read_only'] || sourceNode.parent_uuid === $scope.current.uuid;
        };

        sourceNode.getParent().then(_goTo);

        $scope.$watch('transfer.conflict', function (conflict) {
            if (conflict) {
                $scope.modal.actionButton = buttonOverrideTitle;
            } else {
                $scope.modal.actionButton = actionButton;
            }
        });

        /**
         * Open folder
         * @param {string|Object} destination Destination folder:
         *                                    - Object - instance of Node resource
         *                                    - string - Folder UUID
         */
        function _goTo(destination) {
            if (!$scope.modal.loading) {
                $scope.modal.loading = true;
            }

            var destinationPromise,
                destinationUUID;

            if (angular.isString(destination)) {
                destinationPromise = sourceNode.$get.call({}, {uuid: destination});
                destinationUUID = destination;
            } else {
                destinationPromise = $q.resolve(destination);
                destinationUUID = destination.uuid;
            }

            var destinationContentPromise = sourceNode.constructor.getChildren({
                fields: FIELDS,
                filter_deleted: 'active',
                filter_directory: 'directories',
                filter_not: isSingleSourceNode ? sourceNode.uuid : null,
                page: 1,
                per_page: 10000,
                uuid: destinationUUID
            }).$promise;

            return $q.all([
                destinationPromise,
                destinationContentPromise
            ])
                .then(function (response) {
                    $scope.current = response[0];
                    $scope.currentChildren = response[1];

                    $scope.transfer.destination = $scope.current;
                    $scope.transfer.conflict = false;

                    _updateTitle();
                })
                .finally(function () {
                    $scope.modal.loading = false;
                });
        }

        function _updateTitle() {
            $scope.modal.title = $translate.instant(
                actionTitle +
                (isSingleSourceNode ? " '%{moved_node_name}'" : '') +
                " to '%{new_parent_name}'",
                {
                    moved_node_name: sourceNode.name,
                    new_parent_name: $scope.current.name
                }
            );
        }
    }]);
